export default {
  returnProduct: 'Tuotteen palauttaminen',
  returnOrder: 'Tilauksen palauttaminen',
  introduction:
    'Jos haluat palauttaa tai reklamoida tuotteen, suosittelemme, että asioit myymälässä. Jos sinun ei ole mahdollista asioida jossakin myymälöistämme, voit tehdä palautuksen myös postitse. Alta voit etsiä lähimmän myymäläsi tai pääset täyttämään tilauksesi tiedot palauttamista varten. Lue reilut ostoehtomme alta.',
  searchStoreDescription:
    'Tiesithän, että voit myös palauttaa tai reklamoida tuotteen johonkin myymälöistämme? Etsi myymälä alta.',
  searchStoreTitle: 'Tee palautus myymälässä',
  searchStoreLabel: 'Myymälän nimi tai paikkakunta',
  searchStoreButton: 'Etsi myymälä',
  searchOrderTitle: 'Tee palautus postitse',
  searchOrderDescription:
    'Palautusten tekeminen verkossa on helppoa, jatka täyttämällä tilausnumero ja postinumero.',
  orderNumber: 'Tilausnumero',
  postCode: 'Postinumero',
  findOrder: 'Etsi tilaus',
  errorNumbersOnly: 'Postinumero voi sisältää vain numeroita.',
  errorPostCodeFiveChars: 'Postinumerossa tulee olla 5 merkkiä.',
  orderError: 'Tilausta ei löytynyt.',
  orderErrorPart1: 'Emme löytäneet tilaustasi. Ota yhteyttä ',
  orderErrorPart2: 'https://www.clasohlson.com/fi/contact-us',
  orderErrorPart3: 'asiakaspalveluumme',
  orderErrorPart4: ' jatkaaksesi palautusta.',
  loginBtnText: 'Tai kirjaudu sisään ja valitse tilaus',
  termsTitle: 'Ostoehtomme',
  termsDescription:
    'Meillä on pitkät perinteet hyvän asiakaspalvelun tarjoamisesta asiakkaillemme, minkä vuoksi haluamme taata myös hyvät ostoehdot. Lue lisää napsauttamalla jotakin alla olevista kategorioista.',
  generalError: 'Jokin meni vikaan.',
  deleteRowConfirm: 'Oletko varma, että haluat poistaa tämän tuotteen palautuksesta?',
  stepOneTitle: 'Valitse tuotteet, jotka haluat palauttaa, napsauttamalla niitä',
  stepTwoTitle: 'Valitse toimenpiteet valitsemillesi tuotteille',
  stepThreeTitle: 'Lomake on nyt valmis lähetettäväksi!',
  goBack: 'Palaa takaisin',
  send: 'Lähetä palautuslomake',
  returnSentTitle: 'Lomake on lähetetty!',
  returnSentDescription:
    'Asiakaspalvelumme on sinuun yhteydessä noin 48 tunnin kuluessa ja antaa lisäohjeita palautukseen liittyen.',
  returnSentCloseBtn: 'Sulje ikkuna ja palaa aloitussivulle',
  returnNotSentTitle: 'Jokin meni vikaan.',
  returnNotSentDescription:
    'Yritä lähettää tilaus uudelleen. Jos virhe toistuu, ota yhteyttä asiakaspalveluumme.',
  returnNotSentCloseBtn: 'Sulje',
  productsInOrder: 'Tämän tilauksen tuotteet',
  productsSelected: 'tuote(tta) valittu',
  continue: 'Jatka',
  contactTitle: 'Onko sinulla kysyttävää palautuksestasi?',
  contactDescription: 'Ota yhteyttä asiakaspalveluun, niin autamme sinua',
  contactBtn: 'Ota yhteyttä meihin',
  orderHeaderDescription:
    'Löysimme tilauksesi. Alta löydät tilaukseesi sisältyneet tuotteet. Valitse palautettavat tuotteet ja niiden lukumäärä, niin saat asiakaspalvelustamme palautusohjeet.',
  orderHeaderDescriptionContinue: 'Etsi lähin myymälä.',
  clickHere: 'Napsauta tästä',
  orderNo: 'Tilausnro',
  date: 'Päivämäärä',
  products: 'Tuotteet',
  amount: 'Summa',
  status: 'Tila',
  artNr: 'Tuotenro',
  incVat: 'Sis. ALV:n',
  product: 'Tuote',
  numberOfItems: 'Määrä',
  reasonForReturn: 'Toimenpide',
  selectReason: 'Valitse toimenpide',
  Reklamation: 'Reklamaatio',
  'Öppet köp': 'Palautus',
  selectAction: 'Miksi haluat reklamoida tuotteen? ',
  selectActionOpenPurchase: 'Miksi haluat palauttaa tuotteen? ',
  mustSelectOneReason: 'Valitse vähintään yksi syy alta',
  'Trasig vara': 'Rikkinäinen tuote',
  Transportvara: 'Vahingoittunut kuljetuksessa',
  'Fellevererad vara': 'Väärin toimitettu tuote',
  Annat: 'Jokin muu',
  'Fel produkt': 'Väärä tuote',
  'Fel storlek': 'Väärä koko',
  'Fel färg': 'Väärä väri',
  additionalInformation: 'Lisätietoja',
  processOneTitle: 'Palautusoikeus',
  processOneDescription: 'Hyödynnä jopa 365 päivän palautusoikeus',
  processTwoTitle: 'Palauta',
  processTwoDescription: 'Palautusehdot',
  processThreeTitle: 'Takaisinmaksut',
  processThreeDescription: 'Nopea takaisinmaksu',
  processFourTitle: 'Takuu',
  processFourDescription: 'Vähintään 2 vuoden takuu kaikilla tuotteilla',
  mustEnterNotes:
    'Kirjoita alla olevaan kenttään lisätietoja siitä, miksi haluat reklamoida tuotteen.',
  returnProductError: 'Tätä tuotetta ei voi palauttaa',
  fetchingOrderLabel: 'Etsii tilausta...',
  email: 'Sähköpostiosoite',
  name: 'Nimi',
  privacyStatementText: 'Lue lisää siitä, miten me käsittelemme henkilötietojasi.',
  privacyStatementLinkLabel: 'Tietosuojakäytäntömme',
  privacyStatementLink: 'https://www.clasohlson.com/fi/privacy-statement-contact?isoCode=fi',
  dateFormat: 'dd.MM.yyyy',
  noReturnQtyMessage: 'Täytä palautettavien tuotteiden lukumäärä, jotta voit jatkaa',
};
